/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("variant-picker")) {
  let currentVariant = "";
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".js-product");
      this.productForm = this.section.querySelector(".js-product-form-main");
      this.optionSelectors = this.querySelectorAll(".option-selector");
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener("change", this.handleVariantChange.bind(this));
      currentVariant = this.data.product.variants[0].id;
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      this.product_tempalte = false;
      if (evt.target.closest("product-template")) {
        this.product_tempalte = true;
      }

      this.switsh_image_quick = false;
      console.log(evt.target.getAttribute('name'));

      if (evt.target.closest(".drawer__content") && evt.target.getAttribute('name') == '-couleur-option') {
        this.switsh_image_quick = true;
        let image_id = evt.target.getAttribute('id');
        this.image_src = document.querySelector('.drawer__content .opt-label--swatch[for="' + image_id + '"] img').getAttribute('src');
      }

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(
        new CustomEvent("on:variant:change", {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product,
          },
        })
      );
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector(".js-product-form-main");
      if (!this.productForm) return;

      this.addBtn =
        this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant
        ? theme.strings.noStock
        : theme.strings.noVariant;

      console.log(document.querySelector("[data-option-price]"));

      if (this.variant) {
        this.addBtn.disabled = !variantAvailable;
        if (variantAvailable) {
          if (document.querySelector('[data-subscribe="true"]')) {
            if (
              document
                .querySelector('[data-subscribe="true"]')
                .classList.contains("actif")
            ) {
              if (document.querySelector(".product-option__container.actif")) {
                this.addBtn.textContent =
                  this.addBtn.dataset.addToCartText +
                  " - " +
                  "€" +
                  (this.variant.selling_plan_allocations[0].price *
                    0.9445555 *
                    Number(document.querySelector(".qty-input__input").value)) /
                    100 +
                  Number(
                    document.querySelector("[data-option-price]").dataset
                      .optionPrice / 100
                  ).toFixed(2);
              } else {
                this.addBtn.textContent =
                  this.addBtn.dataset.addToCartText +
                  " - " +
                  "€" +
                  (
                    (this.variant.selling_plan_allocations[0].price *
                      0.9445555 *
                      Number(
                        document.querySelector(".qty-input__input").value
                      )) /
                    100
                  ).toFixed(2);
              }
            } else {
              if (document.querySelector(".product-option__container.actif")) {
                this.addBtn.textContent =
                  this.addBtn.dataset.addToCartText +
                  " - " +
                  "€" +
                  (
                    (this.variant.price *
                      Number(
                        document.querySelector(".qty-input__input").value
                      )) /
                      100 +
                    Number(
                      document.querySelector("[data-option-price]").dataset
                        .optionPrice / 100
                    )
                  ).toFixed(2);
              } else {
                this.addBtn.textContent =
                  this.addBtn.dataset.addToCartText +
                  " - " +
                  "€" +
                  (
                    (this.variant.price *
                      Number(
                        document.querySelector(".qty-input__input").value
                      )) /
                    100
                  ).toFixed(2);
              }
            }
          } else {
            if (document.querySelector(".product-option__container.actif")) {
              this.addBtn.textContent =
                this.addBtn.dataset.addToCartText +
                " - " +
                "€" +
                (
                  (this.variant.price *
                    Number(document.querySelector(".qty-input__input").value)) /
                    100 +
                  Number(
                    document.querySelector("[data-option-price]").dataset
                      .optionPrice / 100
                  )
                ).toFixed(2);
            } else {
              this.addBtn.textContent =
                this.addBtn.dataset.addToCartText +
                " - " +
                "€" +
                (
                  (this.variant.price *
                    Number(document.querySelector(".qty-input__input").value)) /
                  100
                ).toFixed(2);
            }
          }
        } else {
          this.addBtn.textContent = unavailableStr;
        }

        if (document.querySelector('.navigation-vrac__content [name="add"]')) {
          this.addBtn2 =
            this.addBtn2 ||
            document.querySelector('.navigation-vrac__content [name="add"]');
          this.addBtn2.disabled = !variantAvailable;
          if (variantAvailable) {
            if (document.querySelector('[data-subscribe="true"]')) {
              if (
                document
                  .querySelector('[data-subscribe="true"]')
                  .classList.contains("actif")
              ) {
                if (
                  document.querySelector(".product-option__container.actif")
                ) {
                  this.addBtn2.textContent =
                    this.addBtn2.dataset.addToCartText +
                    " - " +
                    "€" +
                    (
                      this.variant.selling_plan_allocations[0].price *
                        0.9445555 *
                        Number(
                          document.querySelector(".qty-input__input").value
                        ) +
                      Number(document.querySelector("[data-option-price]")) /
                        100
                    ).toFixed(2);
                } else {
                  this.addBtn2.textContent =
                    this.addBtn2.dataset.addToCartText +
                    " - " +
                    "€" +
                    (
                      (this.variant.selling_plan_allocations[0].price *
                        0.9445555 *
                        Number(
                          document.querySelector(".qty-input__input").value
                        )) /
                      100
                    ).toFixed(2);
                }
              }
            } else {
              if (document.querySelector(".product-option__container.actif")) {
                this.addBtn2.textContent =
                  this.addBtn2.dataset.addToCartText +
                  " - " +
                  "€" +
                  (
                    this.variant.price *
                      Number(
                        document.querySelector(".qty-input__input").value
                      ) +
                    Number(document.querySelector("[data-option-price]")) / 100
                  ).toFixed(2);
              } else {
                this.addBtn2.textContent =
                  this.addBtn2.dataset.addToCartText +
                  " - " +
                  "€" +
                  (
                    (this.variant.price *
                      Number(
                        document.querySelector(".qty-input__input").value
                      )) /
                    100
                  ).toFixed(2);
              }
            }
          } else {
            if (document.querySelector(".product-option__container.actif")) {
              this.addBtn2.textContent =
                this.addBtn2.dataset.addToCartText +
                " - " +
                "€" +
                (
                  this.variant.price *
                    Number(document.querySelector(".qty-input__input").value) +
                  Number(document.querySelector("[data-option-price]")) / 100
                ).toFixed(2);
            } else {
              this.addBtn2.textContent =
                this.addBtn2.dataset.addToCartText +
                " - " +
                "€" +
                (
                  (this.variant.price *
                    Number(document.querySelector(".qty-input__input").value)) /
                  100
                ).toFixed(2);
            }
          }
        }
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === "false") return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      if (document.querySelector(".pack-builder")) {
        currentVariant = this.data.product.variants.find((v) =>
          v.options.every((val, index) => val === currVariant.options[index])
        ).id;

        let packBuilderInfos = document.querySelector(".pack-builder__infos");

        if (packBuilderInfos) {
          packBuilderInfos.dataset.productVariantId = currentVariant;
          packBuilderInfos.dataset.productName =
            this.data.product.variants.find((v) =>
              v.options.every(
                (val, index) => val === currVariant.options[index]
              )
            ).title;
          packBuilderInfos.dataset.sachetsTimes = document.querySelector(
            ".format_fieldset input:checked"
          ).dataset.variantMaxItems;
          packBuilderInfos.dataset.sachetsNumber = document.querySelector(
            ".format_fieldset input:checked"
          ).dataset.variantSachetsNumber;
        }

        let variants = this.data.product.variants;

        for (let variant in variants) {
          if (variants[variant].title.includes(currVariant.options[1])) {
            let inputId = document.querySelector(
              '.option-selector__btns input[value="' +
                variants[variant].options[0] +
                '"]'
            ).id;
            let inputLabel = document.querySelector(
              '.option-selector__btns label[for="' + inputId + '"]'
            );
            if (inputLabel.querySelector(".price__current") !== null) {
              inputLabel.querySelector(".price__current").innerHTML =
                Shopify.formatMoney(
                  variants[variant].price,
                  Shopify.money_format
                );
            }
          }
        }
      }

      if (document.querySelector('.vrac-product') && this.product_tempalte == true) {
        if (currVariant.available != undefined) {
          if (currVariant.available) {
            document
              .querySelector(".jc-delivery-date")
              .classList.remove("hidden");
          } else {
            document.querySelector(".jc-delivery-date").classList.add("hidden");
          }
        }
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle("is-unavailable", !available);

        if (optionEl.classList.contains("custom-select__option")) {
          const em = el.querySelector("em");

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute("title");
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll(".js-option").forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (
              option === currVariant.options[optionIndex] &&
              optionIndex !== selectorIndex
            ) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll(".js-option");
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === "dropdown") {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(
                optionEl,
                variant.available,
                !variant.available
              );
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder || this.section.querySelector(".backorder");
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === "none") {
          const backorderProdEl = this.backorder.querySelector(
            ".backorder__product"
          );
          const prodTitleEl = this.section.querySelector(".product-title");
          const variantTitle = this.variant.title.includes("Default")
            ? ""
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      if (evt) {
        const selector = evt.target.closest(".option-selector");
        if (selector.dataset.selectorType === "dropdown") return;

        const colorText = selector.querySelector(".js-color-text");
        if (!colorText) return;

        colorText.textContent =
          evt.target.nextElementSibling.querySelector(".js-value").textContent;
      }
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      console.log(this.section.matches("quick-add-drawer"));

      if (this.section.matches("quick-add-drawer")) {
        this.section.updateMedia(this.variant.featured_media.id, true);
      } else {
        this.mediaGallery =
          this.mediaGallery || this.section.querySelector("media-gallery");
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector("pickup-availability");
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute("available");
        this.pickUpAvailability.innerHTML = "";
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.prices =
        this.prices ||
        document.querySelectorAll(".js-product .product-info__price > .price");

      console.log(this.prices);

      if (document.querySelector('[data-changable-image]') && this.product_tempalte == true) {
        document.querySelectorAll('[data-changable-image]').forEach((elem) => {
          elem.classList.add('hidden');
          elem.classList.remove('full-width');
          elem.classList.remove('swiper-slide');
        })

        document
          .querySelectorAll("[data-changable-image-thumb]")
          .forEach((elem) => {
            elem.classList.add("hidden");
            elem.classList.remove("full-width-thumb");
            elem.classList.remove("swiper-slide");
          });

        let color = this.variant.option2.toLowerCase().replace(/ /g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        console.log(color)
        let index = 0;
        let indexThumb = 0;

        document
          .querySelectorAll(`[data-color-thumb=${color}]`)
          .forEach((elem) => {
            elem.classList.remove("hidden");
            elem.classList.add("swiper-slide");
            if (indexThumb == 0) {
              elem.classList.add("full-width-thumb");
            }
            indexThumb++;
          });

        document.querySelectorAll(`[data-color=${color}]`).forEach((elem) => {
          if (index == 0) {
            elem.classList.add("full-width");
          }
          elem.classList.add("swiper-slide");
          index++;
          elem.classList.remove("hidden");
        });

        if (window.innerWidth < 769) {
          document.querySelector("product-media").updateSwiper();
        }
      }

      if (this.product_tempalte == false && this.switsh_image_quick == true) {
        document.querySelector('.drawer__content .quick-add-info__media img').setAttribute('src', this.image_src);
        //  change image in quick add drawer
        document.querySelector('.drawer__content .quick-add-info__media img').setAttribute('srcset', this.image_src);
      }

      this.prices.forEach((price) => {
        if (!price) return;
        console.log(price);

        if (this.variant) {
          console.log(this.variant);

          const priceCurrentEl = price.querySelector(".price__current");
          const priceWasEl = price.querySelector(".price__was");
          const unitPriceEl = price.querySelector(".unit-price");

          // Update current price and original price if on sale.
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
          if (priceWasEl)
            priceWasEl.innerHTML =
              this.data.formatted[this.variant.id].compareAtPrice || "";

          // Update unit price, if specified.
          if (this.variant.unit_price_measurement) {
            const valueEl = price.querySelector(".unit-price__price");
            const unitEl = price.querySelector(".unit-price__unit");
            const value = this.variant.unit_price_measurement.reference_value;
            const unit = this.variant.unit_price_measurement.reference_unit;

            valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }

          unitPriceEl.hidden = !this.variant.unit_price_measurement;
          price.classList.toggle(
            "price--on-sale",
            this.variant.compare_at_price > this.variant.price
          );

          price.classList.toggle("price--sold-out", !this.variant.available);

          let divided_price =
            document.querySelector(".product-scale-pay")?.dataset.divider;
          if (divided_price) {
            document.querySelector(".product-scale-pay strong").innerHTML =
              (this.variant.price / parseInt(divided_price) / 100).toFixed(2) +
              "€";
          }

          let divided_price_vrac = document.querySelector(
            ".product-form__divided-price"
          )?.dataset.divider;
          let divided_price_vrac_price = Number(divided_price_vrac);
          if (divided_price_vrac) {
            document.querySelector(
              ".product-form__divided-price span span"
            ).innerHTML =
              (
                this.variant.price /
                parseInt(divided_price_vrac_price) /
                100
              ).toFixed(2) + "€";
          }
          if (document.querySelector('[data-subscribe="true"]')) {
            document
              .querySelectorAll(
                '[data-subscribe="true"] .price__current--custom'
              )
              .forEach((elem) => {
                elem.innerHTML =
                  "€" +
                  (
                    this.variant.selling_plan_allocations[0].price / 100
                  ).toFixed(2);
              });
            document
              .querySelectorAll('[data-subscribe="true"] .price__curent--offer')
              .forEach((elem) => {
                elem.innerHTML =
                  "€" +
                  (
                    (this.variant.selling_plan_allocations[0].price *
                      0.9445555) /
                    100
                  ).toFixed(2);
              });
            document.querySelector(
              '[data-subscribe="true"] .price__was'
            ).innerHTML =
              "€" +
              (
                this.variant.selling_plan_allocations[0].compare_at_price / 100
              ).toFixed(2);

            document
              .querySelectorAll('[data-subscribe="true"] .price__curent--offer')
              .forEach((elem) => {
                elem.innerHTML =
                  "€" +
                  (
                    (this.variant.selling_plan_allocations[0].price *
                      0.9445555) /
                    100
                  ).toFixed(2);
              });
          }
        }

        price.querySelector(".price__default").hidden = !this.variant;
        price.querySelector(".price__no-variant").hidden = this.variant;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector(".product-sku__value");
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : "";
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false")
        return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.variant.id}`
      );
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms ||
        this.section.querySelectorAll(
          ".js-product-form-main, .js-instalments-form"
        );

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === "dropdown") {
          selectedOptions.push(
            selector.querySelector(".custom-select__btn").textContent.trim()
          );
        } else {
          selectedOptions.push(selector.querySelector("input:checked").value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
